$(function() {

  var colors = ['#21ba45','#F6BE5C','#b3b3b3'];

  var options = {
    cutoutPercentage: 80,
    legend: null,
    tooltips: {
       enabled: false,
    },
    animation: false
  };

   window.donutStatistics = {
     refresh: function() {
       $('.donut-statistic:not(.initialized)').each(function(){
         var data = {
             labels: $(this).data('statistics-labels'),
             datasets: [
               {
                 backgroundColor: colors,
                 borderWidth: 0,
                 data: $(this).data('statistics-data')
               }
             ]
         };
         var element = $(this).find($(this).data('statistics-canvas')).get(0);
         if (element) {
           new Chart(element, {
               type: 'pie',
               data: data,
               options: options
           });
         };

         $(this).addClass('initialized');
       });
     }
   };

   $(function() {
     donutStatistics.refresh();
   });
});
